import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { EffectsModule } from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './access/login/login.component';
import { LoginService } from './access/login/login.service';
import { UserService } from './shared/user/user.service';
import { AppStoreModule } from './shared/state/app-store.module';
import { modalStateKey } from './shared/modal/state/modal.selectors';
import { ModalReducer } from './shared/modal/state/modal.reducer';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AssociationAccessComponent } from './access/association-access/association-access.component';
import { AssociationAccessCardComponent } from './access/association-access/association-access-card/association-access-card.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AssociationService } from './shared/association/association.service';
import { AccessComponent } from './access/access.component';
import { UserAccessService } from './shared/user/user-access.service';
import { NotificationModule } from './dashboard/header/notifications/notification.module';
import { ExternalAccessService } from './shared/external-access/external-access.service';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localePt);

@NgModule( {
  declarations: [
    AppComponent,
    AccessComponent,
    LoginComponent,
    AssociationAccessComponent,
    AssociationAccessCardComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NotificationModule,
    AppStoreModule,
    StoreModule.forFeature( modalStateKey, ModalReducer ),
    EffectsModule.forRoot( [] ),
    BrowserAnimationsModule,
    ToastrModule.forRoot( {} ),
    TranslateModule.forRoot( {
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [ HttpClient ],
      },
      defaultLanguage: 'pt',
    } ),
    NgbModule,
    ModalModule.forRoot(),
  ],
  providers: [
    LoginService,
    UserAccessService,
    UserService,
    AssociationService,
    ExternalAccessService,
    CookieService,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}
